import { useI18n } from 'builder/hooks/useI18n'
import { useTypedSelector } from 'builder/hooks/useTypedSelector'
import { PersonalEditorField } from './PersonalEditorField'

export const AddressInFurigana = () => {
  const { i18n } = useI18n()
  const addressPronunciation = useTypedSelector(
    state => state.resumeEditor.resume?.addressPronunciation,
  )

  return (
    <>
      {/* Address in Furigana */}
      <PersonalEditorField
        label={i18n.t('builder.resume_editor.address_pronunciation')}
        value={addressPronunciation || ''}
        name="addressPronunciation"
      />
    </>
  )
}
